import {
  parseWebsiteDesignSettingsTheme,
  type WebsiteDesignSettingsTheme,
} from "@/utils/websiteDesignTheme";

export async function fetchPublicWebsiteDesignSettings(): Promise<WebsiteDesignSettingsTheme | null> {
  try {
    const res = await fetch("/api/website-design-settings");
    if (!res.ok) return null;
    const data = (await res.json()) as { websiteDesignSettings?: unknown };
    return parseWebsiteDesignSettingsTheme(data.websiteDesignSettings);
  } catch (error) {
    console.error("Failed to load website design settings:", error);
    return null;
  }
}
